import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/MediumFrequencyPowerSwitchingHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-13.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .mfp { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .mfp-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden; 
  }
  .mfp-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .mfp-hero-overlay {
    position: absolute; inset: 0;
    background: linear-gradient(
      to right,
      rgba(0,0,0,0.85) 0%,
      rgba(0,0,0,0.65) 38%,
      rgba(0,0,0,0.10) 100%
    );
  }
  .mfp-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .mfp-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 520px;
  }
  .mfp-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .mfp-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .mfp-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .mfp-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .mfp-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .mfp-bc-item:hover { color: #EB2019; }
  .mfp-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .mfp-bc-sep img { width: 24px; height: 24px; display: block; }
  .mfp-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .mfp-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .mfp-main-section { padding: 80px 0 120px 0; }
  .mfp-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .mfp-article { flex: 1; min-width: 0; }

  .mfp-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .mfp-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .mfp-meta-item:last-child { border-right: none; padding-right: 0; }
  .mfp-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .mfp-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .mfp-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .mfp-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .mfp-article-body p { margin-bottom: 20px; }
  .mfp-article-body p:last-child { margin-bottom: 0; }

  .mfp-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 5px 0 15px 0; line-height: 160%; display: block;
  }

  .mfp-article-body strong { font-weight: 600; color: #202020; }

  .mfp-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .mfp-red-link:hover { opacity: 0.8; }

  /* Hashtags */
  .mfp-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .mfp-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .mfp-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .mfp-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .mfp-nav-btn:hover { color: #EB2019; }
  .mfp-nav-btn img { width: 40px; height: 40px; display: block; }

  .mfp-share-icons { display: flex; align-items: center; gap: 20px; }
  .mfp-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .mfp-share-icon:hover { opacity: 0.85; }
  .mfp-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .mfp-sidebar { flex: 0 0 475px; }
  .mfp-sidebar-block { margin-bottom: 60px; }
  .mfp-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .mfp-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .mfp-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .mfp-recent-item:hover .mfp-recent-title { color: #EB2019; }
  .mfp-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .mfp-recent-body { flex: 1; min-width: 0; }
  .mfp-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .mfp-social-icons { display: flex; align-items: center; gap: 30px; }
  .mfp-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .mfp-social-icon:hover { opacity: 0.8; }
  .mfp-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .mfp-hero             { height: 350px; }
    .mfp-hero-content     { padding: 0 32px; }
    .mfp-hero-title       { font-size: 30px; }
    .mfp-hero-divider     { width: 100%; max-width: 479px; }
    .mfp-breadcrumb       { padding: 24px 0 0 0; }
    .mfp-breadcrumb-inner { padding: 0 32px; }
    .mfp-inner            { padding: 0 32px; }
    .mfp-main-section     { padding: 48px 0 60px 0; }
    .mfp-main-row         { flex-direction: column; gap: 48px; }
    .mfp-sidebar          { flex: none; width: 100%; }
    .mfp-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .mfp-hero             { height: 360px; }
    .mfp-hero-content     { padding: 0 16px; }
    .mfp-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .mfp-hero-divider     { width: 100%; }
    .mfp-hero-subtitle    { font-size: 14px; }
    .mfp-breadcrumb       { padding: 30px 0 0 0; }
    .mfp-breadcrumb-inner { padding: 0 16px; }
    .mfp-bc-item          { font-size: 14px; gap: 14px; }
    .mfp-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .mfp-bc-sep img       { width: 22px; height: 22px; }
    .mfp-inner            { padding: 0 16px; }
    .mfp-main-section     { padding: 30px 0 60px 0; }
    .mfp-main-row         { flex-direction: column; gap: 60px; }
    .mfp-sidebar          { flex: none; width: 100%; }
    .mfp-article-title    { font-size: 20px; margin-bottom: 15px; }
    .mfp-article-body     { font-size: 14px; }
    .mfp-article-body p   { margin-bottom: 15px; }
    .mfp-meta-item        { font-size: 14px; }
    .mfp-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .mfp-h2               { font-size: 16px; margin: 30px 0 15px 0; }
    .mfp-nav-btn img      { width: 24px; height: 24px; }
    .mfp-nav-btn          { font-size: 14px; }
    .mfp-share-icon img   { width: 34px; height: 34px; }
    .mfp-hashtags         { margin-top: 30px; }
  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-rise-ev-energy-storage-manufacturing",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-sustainability-industrial-air-pollution-control",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-forefront-electrolyzer-rectifier-setups",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-types-importance",
  },
];

export default function MediumFrequencyPowerSwitching() {
  return (
    <div className="mfp">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="mfp-hero">
        <img className="mfp-hero-bg" src={HeroBgImg} alt="Medium Frequency Power Switching Hero" />
        <div className="mfp-hero-overlay" />
        <div className="mfp-hero-content">
          <h1 className="mfp-hero-title">
            The Role of Medium-Frequency Power Switching in Modern Manufacturing
          </h1>
          <hr className="mfp-hero-divider" />
          <p className="mfp-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="mfp-breadcrumb" aria-label="Breadcrumb">
        <div className="mfp-breadcrumb-inner">
          <a href="/" className="mfp-bc-item">Home</a>
          <span className="mfp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="mfp-bc-item">News &amp; Updates</a>
          <span className="mfp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="mfp-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="mfp-main-section">
        <div className="mfp-inner">
          <div className="mfp-main-row">

            {/* ── ARTICLE ── */}
            <article className="mfp-article">

              {/* Meta bar */}
              <div className="mfp-meta-bar">
                <span className="mfp-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="mfp-meta-item"><img src={CalendarIcon} alt="date" /> May 16, 2025</span>
                <span className="mfp-meta-item"><img src={ClockIconImg} alt="time" /> 11:03 am</span>
                <span className="mfp-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="mfp-article-title">
                The Role of Medium-Frequency Power Switching in Modern Manufacturing
              </h1>

              {/* Body */}
              <div className="mfp-article-body">

                <p>Industries today are becoming faster than ever, thanks to the revolutions in factories, power plants, and EV industries. Thus, the demand for faster, more innovative, and more efficient solutions is increasing. Today's machines operate faster than human brains, delivering precision, efficiency and performance.</p>

                <p><a href="/medium-frequency-power-switching" className="mfp-red-link">Medium-frequency power Switching</a> is one powerful innovation that bridges the gap between power supply and innovation by offering a complete package of reliability, adaptability, and precision.</p>

                {/* Article image */}
                <img className="mfp-article-img" src={ArticleImg} alt="Medium Frequency Power Switching" />

                <p>This blog will explore how <strong>Medium-Frequency Power Switching</strong> transforms modern manufacturing, role, applications, and importance.</p>

                <p>But first, what is Medium-Frequency Power Switching?</p>

                <span className="mfp-h2">Let's break it down!</span>

                <p>MFPS is converting AC or DC power into medium-frequency AC using electronic switches like IGBTs. This process improves efficiency and reduces the size and weight of equipment like transformers and filters, enabling a more precise system.</p>

                <span className="mfp-h2">The Role in Modern Industry</span>

                <p><strong>Medium-Frequency Power Switching</strong> brought a quantum jump in critical speed, efficiency, and performance domains.</p>

                <p>Here is a detailed explanation of why it is critical:</p>

                <p><strong>Faster Response Time: Medium-Frequency Switching</strong> ensures faster power flow control, resulting in high-speed automation. This leads to improved accuracy and increased production.</p>

                <p><strong>Lightweight:</strong> Traditional systems required larger and more complex transformers and capacitors. Medium-frequency systems reduce these sizes and weights, allowing lighter and more compact equipment.</p>

                <p><strong>Improved Performance:</strong> It helps ensure the smooth functioning of machines, increases accuracy, and offers better control over processes like heating, welding, and motor speeds, leading to desired results.</p>

                <span className="mfp-h2">Industrial Applications</span>

                <p>Here's how <strong>Medium-Frequency Power Switching</strong> is playing a vital role across industries:</p>

                <p><strong>Steel Industry:</strong> Used for metallurgical processes like heating, melting, and hardening. It offers accurate temperature control for producing quality steel and focuses on reducing energy waste.</p>

                <p><strong>Cement Industry:</strong> Improves process stability by enhancing efficiency in electrical drives and control systems.</p>

                <p><strong>Power Sector:</strong> This sector provides access to efficient power conversion by providing a constant energy supply in renewable energy systems and power electronics.</p>

                <p><strong>Pulp and Paper Industry:</strong> This leads to smoother operations in pumps, fans and paper machines, saving energy and reducing stress.</p>

                <p><strong>General Manufacturing:</strong> Supports high-frequency welding operations, robotics, and automation tools with excellent speed and productivity.</p>

                <span className="mfp-h2">Wrapping up</span>

                <p>Regulatory standards are focused on building smarter, faster and greener industries that align with technology. This shift to <strong>Medium-Frequency Power Switching</strong> is a strategic move as a technical upgrade. It's helping systems become more <strong>precise and efficient</strong>, from steel to paper and cement.</p>

                <p><strong>At Ador Powertron,</strong> we offer <strong>Medium-Frequency Power Switching</strong>, leading the way to innovative solutions that meet the unique needs of each industry. We aim to help your business stay ahead of competitors by polishing your technologies with sustainability, efficiency, and future-ready solutions.</p>

                <p>Ready to upgrade your industrial systems with MFPS?</p>

                <p><a href="/contact" className="mfp-red-link">Contact us today and power your success.</a></p>

                <p className="mfp-hashtags">#mediumfrequencypowerswitching #igbtmodules #adorpowertron<br />#mediumfrequencypower #cleanair</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="mfp-bottom-row">
                <div className="mfp-bottom-nav">
                  <a href="/news/previous" className="mfp-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/next" className="mfp-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="mfp-share-icons">
                  <a href="#" className="mfp-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="#" className="mfp-share-icon" aria-label="Twitter">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="#" className="mfp-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="mfp-sidebar">

              {/* Recent Posts */}
              <div className="mfp-sidebar-block">
                <p className="mfp-sidebar-title">Recent Posts</p>
                <div className="mfp-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="mfp-recent-item">
                      <img src={post.img} alt={post.title} className="mfp-recent-img" />
                      <div className="mfp-recent-body">
                        <span className="mfp-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="mfp-sidebar-block">
                <p className="mfp-sidebar-title">Social Media</p>
                <div className="mfp-social-icons">
                  <a href="#" className="mfp-social-icon" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="#" className="mfp-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}